import { ILang } from "../../i18n/ILang";
import { challengesEn } from "./challenges/en";
import { challengesSv } from "./challenges/sv";
import { discoverMoreEn } from "./discoverMore/en";
import { discoverMoreSv } from "./discoverMore/sv";

import { popularItemsEn } from "./popularItems/en";
import { popularItemsEs } from "./popularItems/es";
import { popularItemsSv } from "./popularItems/sv";

export const data = {
  popularItems: {
    en: popularItemsEn,
    es: popularItemsEs,
    sv: popularItemsSv
  },
  challenges: {
    en: challengesEn,
    es: [],
    sv: challengesSv
  },
  discoverMore: {
    en: discoverMoreEn,
    es: [],
    sv: discoverMoreSv
  }
};

export function getChallanges(lang: ILang) {
  return data.challenges[lang];
}

export function getDiscoverMore(lang: ILang) {
  return data.discoverMore[lang];
}

export function popularItemsWithLang(lang: ILang) {
  return data.popularItems[lang];
}
